import { render, staticRenderFns } from "./CommentPanel.vue?vue&type=template&id=0b2e49ce&scoped=true&"
import script from "./CommentPanel.vue?vue&type=script&lang=js&"
export * from "./CommentPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommentPanel.vue?vue&type=style&index=0&id=0b2e49ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e49ce",
  null
  
)

export default component.exports